import { TextInput, UploadBox } from "components/core";
import { FormikProps } from "formik";
import { FC } from "react";

export interface AttachSupportingDocumentsFormProps {
  form: FormikProps<any>;
  labelText?: string;
}

const AttachSupportingDocumentsForm: FC<AttachSupportingDocumentsFormProps> = ({
  form,
  labelText = "Supporting Documents",
}) => {
  return (
    <div className="space-y-6">
      {/* Input Section */}
      {/* {JSON.stringify(form.values, null, 2)} */}
      <div>
        <UploadBox id="documents" label={labelText} multiple={true} {...form} />
      </div>
    </div>
  );
};

export default AttachSupportingDocumentsForm;
